var render = function render(){var _vm=this,_c=_vm._self._c;return _c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in"},slot:"sign-in"},[_c('div',{attrs:{"slot":"federated-buttons"},slot:"federated-buttons"})]),_c('amplify-sign-up',{attrs:{"slot":"sign-up"},domProps:{"formFields":_vm.formFields},slot:"sign-up"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }